import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSeo } from "../../site/ui";

const LEAVE_MSG = "아직 [완료]를 누르지 않아 저장되지 않은 작업이 있습니다.\n나가면 지금까지 한 작업이 사라집니다. 나갈까요?";

/* 연결도 생성기 — PinWire(backend/app/laona_tool/pinwire.html)를 그대로 띄운다.
   도구는 순수 JS 한 파일이라 React 로 옮기지 않고 iframe 으로 감싼다.
   회원 전용이라 백엔드 /api/laona/tool 이 로그인을 확인한 뒤에만 내준다.
   내 수동 프로젝트(?manual=ID)는 자동 저장하지 않고 도구 상단 [완료]를 눌러야 서버에 저장한다.
   그 밖에는 이 브라우저의 localStorage 에만 남는다.
   (회원은 여기서 직접 만들기 — 배치 · 배선 · 브레드보드까지 무료, 부품 주문은 내 프로젝트에서) */
export default function LaonaWiring() {
  /* ?project=ID — 라오나봇 프로젝트의 설계(연결 리스트)를 도구가 불러가 그린다
     ?manual=ID  — 내 수동 프로젝트. [완료]를 누르면 작업을 서버에 저장한다 (app/laona_manual.py) */
  const { search } = useLocation();
  const qs = new URLSearchParams(search);
  /* ?tab=editor — 상단 '모듈 관리' 버튼(관리자)으로 열면 도구가 모듈 관리 화면부터 보여 준다 */
  const project = qs.get("project"), manual = qs.get("manual");
  const src = manual && /^\d+$/.test(manual) ? `/api/laona/tool?manual=${manual}`
    : project && /^\d+$/.test(project) ? `/api/laona/tool?project=${project}`
    : qs.get("tab") === "editor" ? "/api/laona/tool?tab=editor" : "/api/laona/tool";
  useSeo({
    title: "연결도 만들기 — LaonaBot",
    description:
      "모듈을 끌어다 놓고 핀과 핀을 이어 ESP32 연결도를 직접 그리고, 브레드보드 배치도까지 만들 수 있습니다.",
    path: "/laonabot/wiring",
  });

  /* 도구가 보내는 알림 — 저장 안 한 변경이 있는지(pinwire:dirty).
     저장 안 한 변경이 있으면 창을 닫거나 메뉴 링크로 나가기 전에 한 번 묻는다.
     ([완료] 팝업의 '내 프로젝트로 가기'는 도구가 직접 바깥 창을 /laonabot/projects 로 옮긴다) */
  const dirty = useRef(false);
  useEffect(() => {
    dirty.current = false;
    const onMessage = (e) => {
      if (e.origin !== window.location.origin || !e.data) return;
      if (e.data.type === "pinwire:dirty") dirty.current = !!e.data.dirty;
    };
    const onUnload = (e) => {
      if (!dirty.current) return;
      e.preventDefault();
      e.returnValue = "";
    };
    // 메뉴 등 화면 안 링크 — React Router 보다 먼저(캡처 단계) 받아 막는다
    const onClick = (e) => {
      if (!dirty.current || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = e.target.closest && e.target.closest("a[href]");
      if (!a || a.target === "_blank") return;
      if (window.confirm(LEAVE_MSG)) { dirty.current = false; return; }
      e.preventDefault();
      e.stopPropagation();
    };
    window.addEventListener("message", onMessage);
    window.addEventListener("beforeunload", onUnload);
    document.addEventListener("click", onClick, true);
    return () => {
      window.removeEventListener("message", onMessage);
      window.removeEventListener("beforeunload", onUnload);
      document.removeEventListener("click", onClick, true);
    };
  }, [src]);

  return (
    <div className="lb-toolpage">
      <iframe className="lb-toolframe" src={src} title="PinWire 연결도 생성기" />
    </div>
  );
}
